/**
 * Product-card Swipers with slidesPerView: 'auto' should advance one page:
 * the number of cards that fully fit in the viewport.
 * Numeric slidesPerView is handled by slidesPerGroup in each Swiper config,
 * because Swiper breakpoints overwrite a runtime slidesPerGroup on update().
 */
(function () {
  if (window.saSyncProductSwiperPage) return;

  window.saSyncProductSwiperPage = function (swiper) {
    if (!swiper || swiper.destroyed || swiper.__saSyncingPageGroup) return;
    if (swiper.params.slidesPerView !== 'auto') return;

    const offsetBefore = Number(swiper.params.slidesOffsetBefore) || 0;
    const offsetAfter = Number(swiper.params.slidesOffsetAfter) || 0;
    const size = Math.max(0, (swiper.size || 0) - offsetBefore - offsetAfter);
    const space = Number(swiper.params.spaceBetween) || 0;
    const slides = swiper.slides || [];
    let used = 0;
    let count = 0;

    for (let index = 0; index < slides.length; index += 1) {
      const slideSize = swiper.slidesSizesGrid?.[index] || slides[index].swiperSlideSize || 0;
      if (!slideSize) continue;

      const next = count === 0 ? slideSize : used + space + slideSize;
      if (next > size + 1) break;

      used = next;
      count += 1;
    }

    const group = Math.max(1, count);
    if (swiper.params.slidesPerGroup === group) return;

    swiper.__saSyncingPageGroup = true;
    swiper.params.slidesPerGroup = group;
    swiper.update();
    swiper.__saSyncingPageGroup = false;
  };
})();
